import { NavigateFunction } from "react-router-dom";
import { getOrders } from "../../SalesDep/Orders/OrderSlice";
import { AppDispatch } from "../../../Redux/store";

export const notificationNavigation = async (
    remoteMessage: any,
    dispatch: AppDispatch,
    navigate: NavigateFunction
) => {
    const data = remoteMessage.data
        ? remoteMessage.data
        : remoteMessage

    if (!data) {
        return;
    }

    console.log('Notification data:', data);

    switch (data.view) {
        case 'dashboard':
            console.log('Dashboard type:', data.view);

            navigate('/Dashboard');

            break;

        case 'orders':
            console.log('Order type:', data.view);

            try {
                await dispatch(
                    getOrders({ lookup: data.filter })
                ).unwrap();

                navigate('/Orders+Bids');

            } catch (error) {
                console.error(
                    'Failed to fetch order for notification:',
                    error
                );
            }

            break;

        // case 'orderDetails':
        //     console.log('Order Detail type:', data.view);
        //     console.log('Order ID:', data.orderId);

        //     try {
        //         await dispatch(
        //             getOrders({ lookup: data.orderId })
        //         ).unwrap();

        //         await dispatch(
        //             getOrderDetails(data.orderId)
        //         ).unwrap();

        //         navigationRef.navigate('OrdersNav', {
        //             screen: 'OrderDetail',
        //             params: {
        //                 item: data.orderId
        //             }
        //         });

        //     } catch (error) {
        //         console.error(
        //             'Failed to fetch order for notification:',
        //             error
        //         );
        //     }

        //     break;

        case 'nudges':
            console.log('Nudge type:', data.view);

            navigate('/Nudges');

            break;

        // case 'nudgeDetails':
        //     console.log('Nudge Detail type:', data.view);

        //     navigationRef.navigate('NudgeNav', {
        //         screen: 'NudgeReport'
        //     });
            
        //     break;

        default:
            console.log('Unknown notification type:', data.view);
    }
};